(function($) {
    const $modalSupport = $('#modal-support');
    const $formSupport = $('#support-form');
    const $errorMessage = $('.field-error', $modalSupport);
    $errorMessage.css('color', 'red');

    function clearSupportForm() {
        $('#support-message').val("");

        $errorMessage.hide();
        
        $('.response-message', $modalSupport).hide();
        $('#support-message').prop('disabled', false);
        $('#support-submit').prop('disabled', false);
        
        $('#support-close').hide();
        $('#support-submit').show();
        $('#support-message').parent().show();
    }

    function setSupportResponse(response) {
        $('#support-message').parent().hide();

        $('.response-message', $modalSupport).text(response);
        $('.response-message', $modalSupport).show();

        $('#support-submit').hide();
        $('#support-close').show();
    }

    $('#support-show').on('click', clearSupportForm);

    $formSupport.on('submit', function(e) {
        e.preventDefault();

        let message = $('#support-message').val().trim();

        const data = $formSupport.serializeArray().reduce(function(obj, item) {
            obj[item.name] = item.value;
            return obj;
        }, {});

        console.log('checking data...', data);

        data.message.trim();

        if (!message) {
            $errorMessage.show();
            return;
        } else {
            $errorMessage.hide();
        }

        $.ajax({
            type: 'POST',
            url: $formSupport.attr('action'),
            data: data,
            success: function(data) {
                setSupportResponse("La richiesta è stata inoltrata correttamente.")
            },
            error: function(data) {
                setSupportResponse("Si è verificato un errore durante l'invio della richiesta. Si Prega di riprovare più tardi.")
            }
        })

        $('#support-message').prop('disabled', true);
        $('#support-submit').prop('disabled', true);
    });
})(jQuery);